import clsx from "clsx";
import { RenderElementProps } from "slate-react";

import {
  EditorElement,
  EditorElementType,
} from "@smart/itops-serialisation-basic";

export type ElementRendererProps<
  T extends EditorElementType = EditorElementType,
> = RenderElementProps & {
  element: EditorElement<T>;
  readOnly?: boolean;
  isLinkEnabled?: boolean;
};

export const headingClassNames: Partial<
  Record<"h1" | "h2" | "h3" | "h4" | "h5" | "h6", string>
> = {
  h1: "text-h1",
  h2: "text-h2",
  h3: "text-h3",
  h4: "text-h4",
  h5: "text-h5",
  h6: "text-h6",
};

export const Paragraph = ({
  attributes,
  children,
  element,
}: ElementRendererProps<"paragraph">) => {
  const tag = element.paragraphTag ?? "p";
  const Tag = tag;
  const headingClass =
    tag !== "p" && tag !== "span" ? headingClassNames[tag] : undefined;
  return (
    <Tag className={clsx("block m-0", headingClass)} {...attributes}>
      {children}
    </Tag>
  );
};
